import axios from "../axiosPlugin.js";

export const getKitchenDetailService = data => {
    return axios({
        url: "/api/kitchen/detail",
        method: "get",
        data: {
            data,
        },
    });
};

export const saveKitchenDetail = data => {
  return axios({
      url: "/api/kitchen/save",
      method: "post",
      data: {
          data,
      },
  });
};